(() => {
  'use strict';
  const controllers = new WeakMap();
  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));
  function initialize(root) {
    if (!root || controllers.has(root)) return;
    // Shopify preserves query values when switching language. Normalize only
    // known catalog types to the native filter value rendered for this locale.
    const typeAliases = {tees:['T-Shirts','T-shirt','T-shirts','Camisetas'], sweats:['Sweatshirts','Felpe','Sweats','Sudaderas'], accessories:['Hats','Cappellini','Casquettes','Gorras'], outerwear:['Outerwear','Capispalla','Vêtements d’extérieur','Vestes et manteaux','Prendas de abrigo']};
    const localizedUrl = new URL(location.href);
    const selectedTypes = localizedUrl.searchParams.getAll('filter.p.product_type');
    const typeLinks = Array.from(root.querySelectorAll('.nf-category-nav a'));
    const localizedTypes = selectedTypes.map(value => {
      const link = typeLinks.find(item => typeAliases[item.dataset.gaCategory]?.includes(value));
      return link?.dataset.gaProductType || value;
    });
    if (localizedTypes.some((value, index) => value !== selectedTypes[index])) {
      localizedUrl.searchParams.delete('filter.p.product_type');
      localizedTypes.forEach(value => localizedUrl.searchParams.append('filter.p.product_type', value));
      location.replace(localizedUrl.href);
      return;
    }
    const abort = new AbortController();
    const signal = abort.signal;
    const listen = (target, event, handler, options = {}) => target?.addEventListener(event, handler, {...options, signal});
    const section = root.closest('.shopify-section');
    const following = section?.nextElementSibling;
    const products = following?.matches('.collection-section') ? following : null;
    if (products) products.classList.add('ga-collection-products');
    const chrome = root.querySelector('#ga-collection-chrome');
    const scene = root.querySelector('#ga-scene');
    const track = root.querySelector('#ga-scene-track');
    const plane = root.querySelector('#ga-aircraft');
    const sky = root.querySelector('#ga-sky');
    const copy = root.querySelector('#ga-scene-copy');
    const ending = root.querySelector('#ga-scene-end');
    const isWarbirds = root.dataset.collection === 'warbirds';
    const futurePanel = root.querySelector('#ga-coming-soon');
    const header = document.querySelector('.shopify-section-header');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const compact = matchMedia('(max-width:1024px) and (max-height:740px)');
    const readMotion = () => { try { return localStorage.getItem('ga_collection_motion'); } catch { return null; } };
    let motion = !reduced.matches && !navigator.connection?.saveData && readMotion() !== 'off';
    let inView = true;
    let queued = false;
    let fontFrame = 0;
    const initialFutureLabel = futurePanel?.querySelector('[data-ga-coming-name]')?.textContent || '';
    const originalHidden = products?.hidden || false;

    function resetScene() {
      scene?.style.setProperty('--nf-progress', '0');
      [plane, sky, copy].forEach(element => {
        element?.style.removeProperty('transform');
        element?.style.removeProperty('opacity');
      });
      if (ending) {
        ending.style.opacity = '0';
        ending.style.pointerEvents = 'none';
        ending.inert = true;
        ending.setAttribute('aria-hidden', 'true');
      }
    }
    function measure() {
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const height = chrome?.getBoundingClientRect().height || 0;
      root.style.setProperty('--nf-header-offset', `${headerBottom}px`);
      root.style.setProperty('--nf-chrome', `${height + headerBottom}px`);
      products?.style.setProperty('--ga-collection-sticky-offset', `${height + headerBottom}px`);
      return height + headerBottom;
    }
    function draw() {
      queued = false;
      const offset = measure();
      if (!motion || document.hidden || !inView || !track || !scene) return;
      if (compact.matches && !isWarbirds) { resetScene(); return; }
      const box = track.getBoundingClientRect();
      const progress = clamp((offset - box.top) / Math.max(1, box.height - scene.getBoundingClientRect().height));
      const eased = progress * progress * (3 - 2 * progress);
      const mobile = innerWidth <= (isWarbirds ? 700 : 650);
      if (plane) {
        plane.style.transform = root.dataset.collection === 'commercial'
          ? `translate3d(0,${-eased * (mobile ? 65 : 110)}px,0) scale(${1 + eased * .3})`
          : `translate3d(${-eased * (mobile ? 18 : 12)}vw,${-eased * (mobile ? 45 : 80)}px,0) rotate(${-eased * 7}deg) scale(${1 - eased * .14})`;
        plane.style.opacity = String(1 - clamp((progress - .3) / .6));
      }
      if (sky) sky.style.transform = `translate3d(${eased * 3}%,${eased * 5}%,0) scale(${1.04 + eased * .07})`;
      if (copy && !isWarbirds) {
        copy.style.opacity = String(1 - clamp((progress - .35) / .65) * .35);
        copy.style.transform = `translate3d(0,${-progress * 45}px,0)`;
      }
      if (ending) {
        ending.style.opacity = String(clamp((progress - .52) / .25));
        ending.style.pointerEvents = progress > .62 ? 'auto' : 'none';
        ending.inert = progress <= .62;
        ending.setAttribute('aria-hidden', String(progress <= .62));
      }
      scene.style.setProperty('--nf-progress', progress.toFixed(3));
    }
    function queue() {
      if (queued || signal.aborted) return;
      queued = true;
      requestAnimationFrame(draw);
    }
    function setMotion(enabled, persist = false) {
      motion = enabled && !reduced.matches;
      root.dataset.motion = motion ? 'on' : 'off';
      root.querySelectorAll('button[data-ga-motion-toggle]').forEach(button => {
        button.textContent = motion ? root.dataset.pauseLabel : root.dataset.playLabel;
        button.setAttribute('aria-pressed', String(motion));
      });
      if (persist) { try { localStorage.setItem('ga_collection_motion', motion ? 'on' : 'off'); } catch {} }
      if (!motion || (compact.matches && !isWarbirds)) resetScene();
      queue();
    }
    function fitHeadings() {
      cancelAnimationFrame(fontFrame);
      fontFrame = requestAnimationFrame(() => {
        if (signal.aborted) return;
        root.querySelectorAll('h1').forEach(heading => {
          heading.style.removeProperty('font-size');
          let size = parseFloat(getComputedStyle(heading).fontSize);
          for (let attempt = 0; heading.scrollWidth > heading.clientWidth + 1 && attempt < 10; attempt += 1) {
            size *= .96;
            heading.style.fontSize = `${size}px`;
          }
        });
      });
    }
    function activateFuture(key, shouldFocus = false) {
      if (!futurePanel) return;
      const option = Array.from(root.querySelectorAll('[data-ga-future-category]')).find(link => link.dataset.gaFutureCategory === key);
      const isFuture = Boolean(option);
      const isKids = root.dataset.collection === 'kids';
      futurePanel.hidden = !isFuture && !isKids;
      if (products) products.hidden = isFuture || isKids || originalHidden;
      const label = futurePanel.querySelector('[data-ga-coming-name]');
      if (label) label.textContent = option?.dataset.gaCategoryLabel || option?.querySelector('h2')?.textContent || option?.textContent.trim() || initialFutureLabel;
      root.querySelectorAll('.nf-category-nav a').forEach(link => {
        if (isFuture) {
          link.classList.toggle('active', link.dataset.gaFutureCategory === key);
          if (link.dataset.gaFutureCategory === key) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        } else {
          const selectedType = new URLSearchParams(location.search).get('filter.p.product_type') || '';
          const active = !link.dataset.gaFutureCategory && (link.dataset.gaProductType || '') === selectedType;
          link.classList.toggle('active', active);
          if (active) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        }
      });
      if (shouldFocus && !futurePanel.hidden) {
        futurePanel.focus({preventScroll:true});
        futurePanel.scrollIntoView({behavior:motion ? 'smooth' : 'auto', block:'start'});
      }
    }
    function updateHash() {
      const key = location.hash.match(/^#ga-future-(tees|sweats|accessories|outerwear)$/)?.[1] || '';
      activateFuture(key, Boolean(key));
    }
    function refreshCategoryLink(link) {
      if (!link.hasAttribute('data-ga-category-link') && !link.hasAttribute('data-ga-reset-future')) return;
      const url = new URL(location.href);
      if (link.dataset.gaFutureCategory) url.hash = `ga-future-${link.dataset.gaFutureCategory}`;
      else {
        url.searchParams.delete('filter.p.product_type');
        if (link.dataset.gaProductType) url.searchParams.set('filter.p.product_type', link.dataset.gaProductType);
        url.searchParams.delete('page');
        url.hash = 'ga-products';
      }
      link.href = url.href;
    }
    function refreshCategoryLinks() {
      root.querySelectorAll('[data-ga-category-link],[data-ga-reset-future]').forEach(refreshCategoryLink);
      const key = location.hash.match(/^#ga-future-(tees|sweats|accessories|outerwear)$/)?.[1] || '';
      activateFuture(key);
    }
    function restoreNativeSort() {
      const selectedSort = new URLSearchParams(location.search).get('sort_by');
      if (selectedSort) products?.querySelectorAll('.facet-sort-select').forEach(select => {
        const option = Array.from(select.querySelectorAll('.facet-sort-select__option')).find(item => item.dataset.value === selectedSort);
        const label = select.querySelector('.facet-sort-select__current');
        const input = select.querySelector('input[name="sort_by"]');
        if (option && label && label.textContent !== option.textContent) label.textContent = option.textContent;
        if (input) input.value = selectedSort;
      });
    }
    function preservePreview(link) {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const params = new URLSearchParams(location.search);
      ['preview_theme_id','_fd','pb'].forEach(key => {
        if (params.has(key)) url.searchParams.set(key, params.get(key));
      });
      const previewViews = {men:'ga-men', women:'ga-women', kids:'ga-kids', 'commercial-icons':'ga-commercial', warbirds:'ga-warbirds'};
      const targetView = previewViews[url.pathname.split('/').filter(Boolean).pop()];
      if (/^ga-(men|women|kids|commercial|warbirds)$/.test(params.get('view') || '') && targetView) {
        url.searchParams.set('view', targetView);
      }
      link.href = url.href;
    }
    root.querySelectorAll('a[href]').forEach(preservePreview);
    document.querySelectorAll('#ga-collection-related a[href]').forEach(preservePreview);
    // Zenith excludes product-type values from forms other than the submitted
    // one. Include the current type in its native sort form on these pages only.
    listen(products, 'formdata', event => {
      if (!['FacetSortForm', 'FacetSortDrawerForm'].includes(event.target.id)) return;
      const key = 'filter.p.product_type';
      event.formData.delete(key);
      new URLSearchParams(location.search).getAll(key).forEach(value => event.formData.append(key, value));
    }, {capture:true});
    listen(root, 'click', event => {
      const motionButton = event.target.closest('button[data-ga-motion-toggle]');
      if (motionButton) { setMotion(!motion, true); return; }
      const link = event.target.closest('a');
      if (!link) return;
      if (link.classList.contains('nf-collection-name')) {
        event.preventDefault();
        window.scrollTo({top:0, behavior:motion ? 'smooth' : 'auto'});
        return;
      }
      refreshCategoryLink(link);
      if (link.dataset.gaFutureCategory) activateFuture(link.dataset.gaFutureCategory);
      if (link.hasAttribute('data-ga-reset-future')) activateFuture('');
    });
    listen(window, 'scroll', queue, {passive:true});
    listen(window, 'resize', () => { resetScene(); queue(); fitHeadings(); }, {passive:true});
    listen(window, 'hashchange', () => { refreshCategoryLinks(); updateHash(); });
    listen(window, 'popstate', () => { refreshCategoryLinks(); restoreNativeSort(); });
    ['pointerdown','contextmenu','focusin'].forEach(eventName => listen(root, eventName, event => {
      const link = event.target.closest('a');
      if (link) refreshCategoryLink(link);
    }, {capture:true}));
    listen(reduced, 'change', () => setMotion(!reduced.matches && readMotion() !== 'off'));
    listen(compact, 'change', () => { resetScene(); queue(); });
    listen(document, 'visibilitychange', () => {
      root.classList.toggle('nf-paused', document.hidden);
      if (!document.hidden) queue();
    });
    listen(document, 'transitionend', event => { if (header?.contains(event.target)) queue(); });
    const productObserver = products && typeof MutationObserver === 'function' ? new MutationObserver(refreshCategoryLinks) : null;
    productObserver?.observe(products, {childList:true, subtree:true});
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
    if (chrome) resizeObserver?.observe(chrome);
    if (header) resizeObserver?.observe(header);
    const visibilityObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        inView = entry.isIntersecting;
        entry.target.classList.toggle('nf-scene-in-view', inView);
        if (inView) queue();
      });
    }) : null;
    if (scene) {
      if (visibilityObserver) visibilityObserver.observe(scene);
      else scene.classList.add('nf-scene-in-view');
    }
    controllers.set(root, () => {
      abort.abort();
      cancelAnimationFrame(fontFrame);
      resizeObserver?.disconnect();
      productObserver?.disconnect();
      visibilityObserver?.disconnect();
      if (products) { products.hidden = originalHidden; products.classList.remove('ga-collection-products'); products.style.removeProperty('--ga-collection-sticky-offset'); }
      controllers.delete(root);
    });
    setMotion(motion);
    refreshCategoryLinks();
    updateHash();
    fitHeadings();
    document.fonts?.ready.then(fitHeadings);
  }
  function boot() { initialize(document.getElementById('ga-collections')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('#ga-collections').forEach(root => controllers.get(root)?.());
  });
})();

